import { useState, useEffect } from 'react';
// @mui
import {
  Typography,
  Box,
  Container,
  Grid,
  Card,
  CardHeader,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  FormControl,
  FormGroup,
  Switch,
  Stack
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Helmet } from 'react-helmet-async';
import store from 'store2';
// components
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import axiosInstance from '../../utils/axiosInstance';
import MultiSelector from '../multi-selector/multiSelector';

const customPathCondition = () => {
  const p = store('ingressController');
  if (p !== 'disable' && p !== '/device-proxy/vms' && p !== '/vms') {
    return false;
  }
  return true;
};

export default function SystemControls() {
  const { enqueueSnackbar } = useSnackbar();
  const { adaptorType } = window;
  const [liveStreamLogging, setLiveStreamLogging] = useState(false);
  const [vodStreamLogging, setVodStreamLogging] = useState(false);
  const [ingressController, setIngressController] = useState(
    store('ingressController') == null ? 'disable' : store('ingressController')
  );
  const [customPath, setCustomPath] = useState(
    customPathCondition() ? '' : store('ingressController')
  );
  const [inputValue, setInputValue] = useState('');
  const cameraList = useSelector((state) => state.app.cameraList);
  const [selectedCameraList, setSelectedCameraList] = useState([]);

  const hostList = useSelector((state) => state.app.hostList);
  const [vstDevice, setVstDevice] = useState(
    hostList.length > 0 ? hostList[0] : null
  );

  useEffect(() => {
    setSelectedCameraList([]);
  }, [cameraList]);

  const handleSelectedCameraListChange = (val) => {
    setSelectedCameraList(val);
  };

  const handleInputValue = (val) => {
    setInputValue(val);
  };

  const handleCustomPath = (e) => {
    setCustomPath(e.target.value);
    handleProxyChange(e);
  };

  const handleProxyChange = (e) => {
    if (e.target.value === 'disable') {
      setIngressController('disable');
      store.set('ingressController', 'disable');
    } else {
      console.log('path', e.target.value);
      setIngressController(e.target.value);
      store.set('ingressController', e.target.value);
    }
  };

  const handleDisconnectClients = () => {
    axiosInstance
      .get(
        `${window.location.protocol}//${vstDevice}/api/getPeerConnectionList`
      )
      .then((res) => {
        if (res.data == null) {
          enqueueSnackbar(`No clients to disconnect`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        } else {
          enqueueSnackbar(`disconnecting clients... `, {
            variant: 'info',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
          const peerIds = res.data.map((x) => Object.keys(x)[0]);
          for (let i = 0; i < peerIds.length; i += 1) {
            axiosInstance
              .post(
                `${window.location.protocol}//${vstDevice}/api/stream/stop`,
                { peerid: peerIds[i] }
              )
              .then(() => { })
              .catch(() => {
                enqueueSnackbar(`Error - failed to disconnect clients`, {
                  variant: 'error',
                  anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
                });
              });
          }
          enqueueSnackbar(`disconnect clients done `, {
            variant: 'success',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        }
      })
      .catch((error) => {
        console.log('Could not fetch clients data', error);
        enqueueSnackbar(`Error - Could not fetch clients data`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  };

  const handleVstDeviceChange = (e) => {
    setVstDevice(e.target.value);
  };

  const handleLiveStreamLoggingChange = () => {
    setLiveStreamLogging(!liveStreamLogging);
  };

  const handleVodStreamLoggingChange = () => {
    setVodStreamLogging(!vodStreamLogging);
  };

  const getLoggingStatus = () => {
    axiosInstance
      .get(
        `${window.location.protocol}//${vstDevice}/api/v1/sensor/debug/logging`
      )
      .then((response) => {
        const { data } = response;
        console.log('Debug Logging status: ', data);
        if (data) {
          if (Object.prototype.hasOwnProperty.call(data, 'live_stream')) {
            setLiveStreamLogging(data.live_stream);
          }
          if (Object.prototype.hasOwnProperty.call(data, 'vod_stream')) {
            setVodStreamLogging(data.vod_stream);
          }
        }
      })
      .catch((e) => {
        console.log('Failed to fetch logging status', e);
        enqueueSnackbar(`Error - Could not Get logging data`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  };

  const setLoggingStatus = () => {
    axiosInstance
      .post(
        `${window.location.protocol}//${vstDevice}/api/v1/sensor/debug/logging`,
        {
          "live_stream": liveStreamLogging,
          "vod_stream": vodStreamLogging
        }
      )
      .then(() => { })
      .catch((error) => {
        console.log('Could not update logging data', error);
        enqueueSnackbar(`Error - Could not update logging data`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  };

  const handlUnPlug = () => {
    console.log("selectedCameraList: ", selectedCameraList)
    for (let i = 0; i < selectedCameraList.length; i += 1) {
      axiosInstance
        .post(
          `${window.location.protocol}//${vstDevice}/api/v1/sensor/debug/unplug`,
          {
            "ip": selectedCameraList[i].sensorIp,
            "action": "unplug"
          }
        )
        .then(() => { })
        .catch((error) => {
          console.log(`Could not unplug device ${selectedCameraList[i].name}`, error);
          enqueueSnackbar(`Error - Could not unplug device ${selectedCameraList[i].name}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        });
    }
  }

  const handlePlug = () => {
    for (let i = 0; i < selectedCameraList.length; i += 1) {
      axiosInstance
        .post(
          `${window.location.protocol}//${vstDevice}/api/v1/sensor/debug/plug`,
          {
            "ip": selectedCameraList[i].sensorIp,
            "action": "plug"
          }
        )
        .then(() => { })
        .catch((error) => {
          console.log(`Could not plug device ${selectedCameraList[i].name}`, error);
          enqueueSnackbar(`Error - Could not plug device ${selectedCameraList[i].name}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        });
    }
  }

  return (
    <>
      <Helmet>
        <title> Debug </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h5" sx={{ mb: 5 }}>
          System controls
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={6}>
            <Card>
              <CardHeader
                title={'Ingress controller'}
                subheader={'Enable-disable ingress controller'}
              />
              <Box sx={{ p: 3 }}>
                <RadioGroup
                  value={ingressController}
                  onChange={handleProxyChange}
                >
                  <FormControlLabel
                    value="/vms"
                    control={<Radio />}
                    label="/vms"
                  />
                  <FormControlLabel
                    value="/device-proxy/vms"
                    control={<Radio />}
                    label="/device-proxy/vms"
                  />
                  <FormControlLabel
                    value={customPath}
                    control={<Radio />}
                    label="custom"
                  />
                  <FormControlLabel
                    value="disable"
                    control={<Radio />}
                    label="disable"
                  />
                </RadioGroup>
                <TextField
                  name="custom-path"
                  label="custom-path"
                  value={customPath}
                  onChange={handleCustomPath}
                />
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Card>
              <CardHeader
                title={'Stream timestamp logging'}
                subheader={'Enable-disable timestamp logging for streams'}
              />
              <Box sx={{ p: 3 }}>
                <LoadingButton
                  size="small"
                  type="submit"
                  variant="outlined"
                  onClick={getLoggingStatus}
                >
                  Get current status
                </LoadingButton>
                <FormGroup>
                  <FormControlLabel control={
                    <Switch checked={liveStreamLogging} onChange={handleLiveStreamLoggingChange} />
                  } label="Live Stream" />
                  <FormControlLabel control={
                    <Switch checked={vodStreamLogging} onChange={handleVodStreamLoggingChange} />
                  } label="Vod Stream" />
                </FormGroup>
                <Box
                  m={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                >
                  <LoadingButton
                    size="large"
                    type="submit"
                    variant="contained"
                    onClick={setLoggingStatus}
                  >
                    Set status
                  </LoadingButton>
                </Box>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Card>
              <CardHeader
                title={'Disconnect clients'}
                subheader={'Disconnect all clients'}
              />
              <Box sx={{ p: 3 }}>
                <FormControl>
                  <RadioGroup
                    row
                    name="vst-device-radio-button"
                    value={vstDevice}
                    onChange={handleVstDeviceChange}
                  >
                    {hostList.map((host) => (
                      <FormControlLabel
                        value={host}
                        control={<Radio />}
                        label={`${adaptorType} ${host}`}
                        key={host}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
                <Box
                  m={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                >
                  <LoadingButton
                    size="large"
                    type="submit"
                    variant="contained"
                    onClick={handleDisconnectClients}
                  >
                    Disconnect all
                  </LoadingButton>
                </Box>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Card>
              <CardHeader
                title={'Plug-Unplug Sensors'}
                subheader={'Debug option to plug and unplug sensors'}
              />
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <MultiSelector
                    id="plug-unplug-camera-selector"
                    placeholder="Type to search"
                    label={`Select multiple sensors`}
                    value={selectedCameraList}
                    inputValue={inputValue}
                    onInputChange={handleInputValue}
                    onChange={handleSelectedCameraListChange}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={cameraList}
                  />
                </Stack>
                <Box
                  m={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                >
                  <LoadingButton
                    size="large"
                    type="submit"
                    variant="contained"
                    onClick={handlePlug}
                    sx={{ mr: 1 }}
                  >
                    Plug
                  </LoadingButton>
                  <LoadingButton
                    size="large"
                    type="submit"
                    variant="contained"
                    onClick={handlUnPlug}
                  >
                    Unplug
                  </LoadingButton>
                </Box>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
